<template>
	<div>
		<div class="card panel panel-default actions">
		    <div class="card-block">
		        <div class="header-block clearfix">
		            <h3 class="pull-left">Display Groups</h3>
		            <button v-on:click="saveAttributesAndDisplayGroups(attributes, displayGroups)" class="btn btn-primary pull-right">
						<span v-if="uiStates.showSaving"><i class="fa fa-spinner fa-pulse fa-fw"></i> {{uiStates.saveMessage}}</span>
						<span v-else>{{uiStates.saveMessage}}</span>
		            </button>

					<button v-if="this.$parent.isFeatureAllowed('manage_workflow')" v-on:click="confirmSaveAndSync(attributes, displayGroups)" class="btn btn-primary pull-right">
						<span v-if="uiStates.showSaving"><i class="fa fa-spinner fa-pulse fa-fw"></i> {{uiStates.saveMessage}}</span>
						<span v-else>{{uiStates.saveAndSyncMessage}}</span>
		            </button>
		        </div>
		    </div>
		</div>
		<transition name="fade">
			<div v-if="uiStates.errorMessage !== ''" class="alert alert-danger ks-solid-light ks-active-border" role="alert">
	            <button type="button" class="close" v-on:click="uiStates.errorMessage = ''">
	                <span aria-hidden="true" class="la la-close"></span>
	            </button>
	            <i class="fa fa-times-circle ks-icon" aria-hidden="true"></i> {{uiStates.errorMessage}}
	        </div>
        </transition>
		<div style="position: relative;">
			<transition name="vue-table-loader">
			    <div class="vue-table-loader" v-if="uiStates.showLoading"><span class="fa fa-cog fa-spin fa-3x"></span></div>
			</transition>
			<div class="row">
				<div class="col-md-12 text-right">
					<a v-if="uiStates.collapsePanelToggle" class="view-collapse-all" href="#" v-on:click="collapseAll()">
						Collapse All
					</a>
					<a v-else class="view-collapse-all" href="#" v-on:click="expandAll()">
						Expand All
					</a>
				</div>
			</div>
		    <div class="row">
		    	<div class="col-md-6">
		    		<div class="card panel panel-default actions">
		    			<div class="card-title no-actions panel-border-bottom">
		    				<strong>Default</strong>
		    				<input @keyup.enter="searchAttributes(searchCriteria)" placeholder="Search..." v-model="searchCriteria" class="form-control attribute-search" type="text">
		    				<button v-on:click="searchAttributes(searchCriteria)" class="seach-icon"><i class="fa fa-search" aria-hidden="true"></i></button>
		    			</div>
	    		       <div class="card-body">
		    		       	<transition name="vue-table-loader">
		    		       	    <div class="vue-table-loader alt" v-if="uiStates.showSearchLoading"><span class="fa fa-cog fa-spin fa-3x"></span></div>
		    		       	</transition>
				    		<draggable :options="{group:{ name:'attributes'}}" v-model="attributes">
				    		    <transition-group name="list-complete">
				    		        <div class="attribute-item clearfix" v-for="attribute in attributes" :key="attribute.id">
				    		            <div class="pull-left">
				    		            	<strong>{{attribute.name}}</strong>
				    		            </div>
				    		            <a target="_blank" :href="'/attributes/'+ attribute.id +'/edit'" class="pull-right view-attribute"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></a>
				    		            <!-- <a target="_blank" :href="'/attributes/'+ attribute.id +'/edit'" class="pull-right badge badge-primary-outline">View</a> -->
				    		        </div>
				    		    </transition-group>
				    		</draggable>
				    		<div class="search-no-attributes" v-if="attributes.length == 0">
				    			No Attributes Match That Name...
				    		</div>
				    	</div>
				    </div>
		    	</div>
				<!-- // HERE NICK -->
		    	<div class="col-md-6">
		    		<draggable v-model="displayGroups">
			    		<div v-for="(group, index) in displayGroups" :class="{deleted: group.isDeleted}" class="card panel panel-default editable-display-group" :id="removeSpclChars(group.name)" :key="index">
		    				<div v-if="group.nameEditable" class="input-group display-group-form-control">
			    				<input v-model="group.name" type="text" class="form-control form-name-display-group" placeholder="New group">
			    				<div class="input-group-append">
			    				    <button class="btn btn-primary" v-on:click="setName(index)" type="button">Save Name</button>
			    				</div>
			    				<div v-if="group.groupError != ''" class="name-error-message">
			    					{{group.groupError}}
			    				</div>
			    			</div>
			    			<div v-else class="card-title actions editable-group clearfix">
								<i  @click="togglePanel(removeSpclChars(group.name))" class="toggle-panel-icon fa ks-icon fa-chevron-right"></i>
			    				<div class="copy pull-left pl-3">
			    					{{ group.name }}
			    				</div>
			    				<button v-on:click="markDeletion(group)" class="btn btn-danger btn-flag-for-deletion pull-right">
			    					<span v-if="group.isDeleted" class="btn-cancel-deletion">
			    						<span class="pull-left marked-for-deletion">
											This Display Group will be deleted on the next save.
			    						</span>
			    						<span class="btn-cancel pull-right">
			    							Cancel Deletion?
			    						</span>
			    					</span>
			    					<i v-else class="fa fa-trash" aria-hidden="true"></i>
			    				</button>
			    				<button v-on:click="markEditMode(group)" class="btn btn-outline-primary btn-flag-for-name-edit pull-right">
			    					<i class="fa fa-pencil" aria-hidden="true"></i>
			    				</button>
			    				<transition name="fade">
				    				<label v-if="!group.isDeleted" class="navigationable-switch ks-checkbox-switch pull-right ks-info">
			          				<input v-model="group.isInNavigation" type="checkbox" value="1">
			                            <span class="ks-wrapper"></span>
			                            <span class="ks-indicator"></span>
			                            <span class="ks-on">Tabbed</span>
			                            <span class="ks-off">Normal</span>
			                        </label>
		                        </transition>
			    			</div>
							<transition name="fade">
			    		       <div v-if="!group.isDeleted" class="card-body created-display-groups">
			    		           <draggable class="dragArea" :options="{group:'attributes'}" v-model="group.attributes">
			    		               <transition-group name="list-complete">
			    		                   <div class="attribute-item clearfix" v-for="groupAttribute in group.attributes" :key="groupAttribute.id">
			    		                       <div class="pull-left">
			    		                       		<strong>{{groupAttribute.name}}</strong>
			    		                       </div>
			    		                       <a target="_blank" :href="'/attributes/'+ groupAttribute.id +'/edit'" class="pull-right view-attribute"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></a>
			    		                   </div>
			    		               </transition-group>
			    		           </draggable>
			    		           	<div class="no-attribute-message" v-if="group.attributes.length === 0">Add an Attribute</div>
			    		       </div>
							</transition>
		    		   </div>
	    		   </draggable>
	    		   <div class="add-display-group" v-if="uiStates.createDisplayGroupVisible" v-on:click="addDisplayGroup">
	    		   		<i class="fa fa-plus-square" aria-hidden="true"></i> Add Display Group
	    		   </div>
		    	</div>
		    </div>
		</div>
	</div>
</template>

<script type="text/javascript">
	import Vue from 'vue';
	import VueEvents from 'vue-events'
	import draggable from 'vuedraggable'
	import axios from 'axios'
	Vue.use(VueEvents)

	const base_url = window.location.protocol + "//" + window.location.host

	export default {
	    name: 'attribute-display-groups',
	    props: [],
	    components:{
			draggable,
	    },
	    data() {
	    	return {
				attributesLoaded: false,
				displayGroupsLoaded: false,
	    		uiStates: {
					showLoading: false,
					showSearchLoading: false,
					showSaving: false,
					saveMessage: 'Save Display Groups',
					saveAndSyncMessage: 'Save and Workflow Sync',
					errorMessage: '',
					createDisplayGroupVisible: true,
					collapsePanelToggle: false
	    		},
	    		searchCriteria: '',
	    		attributes: [],
				displayGroups: [],
			}
	    },
	    mounted() {
	    },
	    created() {
			this.loadAttributes(this.searchCriteria);
			this.loadDisplayGroups();
		},
	    watch: {
			displayGroups: {
                handler() {
                	this.uiStates.saveMessage = 'Save Display Groups';
                },
                deep: true
            },
	    },
	    methods: {
			collapseAll(){
				this.uiStates.collapsePanelToggle = !this.uiStates.collapsePanelToggle;
				$('.editable-display-group').removeClass('open');
			},
			expandAll(){
				this.uiStates.collapsePanelToggle = !this.uiStates.collapsePanelToggle;
				$('.editable-display-group').addClass('open');
			},
			togglePanel(group){
				$('#'+group).toggleClass('open');
			},
			removeSpclChars(str) {
				if (str == null) {
					return;
                }
                let spacesRemoved = str.replace(/\s+/g, '').toLowerCase();
                let spclRemoved = spacesRemoved.replace(/[^\w\s]/gi, '');
                return spclRemoved;
			},
			toggleLoading: function(attributesLoaded, displayGroupsLoaded){
				if(attributesLoaded && displayGroupsLoaded){
					this.uiStates.showLoading = false;
				} else {
					this.uiStates.showLoading = true;
				}
				this.attributesLoaded = attributesLoaded;
				this.displayGroupsLoaded = displayGroupsLoaded;
			},
            onMove: function(evt, originalEvent) {
            	console.log('Moving: ' + evt.draggedContext.element.name + '(' + evt.draggedContext.element.id+')');
			},
            saveAttributesAndDisplayGroups: function (attributes, displayGroups, sync = false) {
				this.uiStates.showSaving = true;
				this.uiStates.showLoading = true;
				this.uiStates.saveMessage = 'Saving...';

                axios.post('/attributes/display-groups/save', {
                	'displayGroups': displayGroups,
                	'attributes': attributes,
					'shouldSync': sync
               	}).then(function (response) {
					this.uiStates.showSaving = false;
                    this.uiStates.saveMessage = 'Display Groups Saved!';
                    this.loadAttributes(this.searchCriteria);
					this.loadDisplayGroups();
                    this.uiStates.showLoading = false;
				}.bind(this)).catch(function (error) {
                    this.uiStates.showSaving = false;
                    this.uiStates.errorMessage = 'An error has occured!';
                    this.uiStates.saveMessage = 'Save Display Groups';
				}.bind(this));
            },
			confirmSaveAndSync: function (attributes, displayGroups) {
				const userConfirmed = confirm("This will SYNC ALL PRODUCTS. Are you sure you want to save the Display Groups and sync all products?");

				if (userConfirmed) {
					this.saveAttributesAndDisplayGroups(attributes, displayGroups, true);
				}
			},
            addDisplayGroup: function (group) {
            	this.uiStates.createDisplayGroupVisible = false;
            	var newGroup = {
            		name:null,
            		nameEditable:true,
            		isInNavigation:false,
            		isDeleted:false,
                    isDetails:false,
                    id:null,
            		groupError: '',
            		attributes: []
            	};
				this.displayGroups.push(newGroup);
				Vue.nextTick(function () {
					$(".form-name-display-group").focus();
				})

            },
            markDeletion: function (group) {
            	group.isDeleted = !group.isDeleted
            },
            markEditMode: function (group) {
            	group.nameEditable = !group.nameEditable
            },
            setName: function (index) {
            	if (this.displayGroups[index].name !== null) {
					this.uiStates.createDisplayGroupVisible = true;
					this.displayGroups[index].nameEditable = false;
					$('#'+this.removeSpclChars(this.displayGroups[index].name)).addClass('open');
            	}else{
					this.displayGroups[index].groupError = 'A name is required';
            	}
            },
            loadDisplayGroups: function () {
				this.uiStates.showLoading = true;
                axios.get('/attributes/display-groups/get-groups', {
                    // 'criteria': criteria,
                })
                .then(function (response) {
					this.displayGroups = Object.values(response.data);
					this.toggleLoading(this.attributesLoaded, true);
                }.bind(this))
                .catch(function (error) {
					console.log(error);
                    this.uiStates.errorMessage = 'An error has occured!';
					this.uiStates.showLoading = false;
                }.bind(this));
            },
            loadAttributes: function (criteria) {
                 axios.post('/attributes/display-groups/get-listing', {
                    'criteria': criteria,
                })
                .then(function (response) {
					this.attributes = response.data;
					this.toggleLoading(true, this.displayGroupsLoaded);
                }.bind(this))
                .catch(function (error) {
					console.log(error);
                    this.uiStates.errorMessage = 'An error has occured!';
                }.bind(this));
            },
            searchAttributes: function (criteria) {
            	this.uiStates.showSearchLoading = true;
				 axios.post('/attributes/display-groups/get-listing', {
				    'criteria': criteria,
				})
				.then(function (response) {
					this.attributes = response.data;
					this.uiStates.showSearchLoading = false;
				}.bind(this))
				.catch(function (error) {
				    console.log('Error with search');
				    this.uiStates.showSearchLoading = false;
				}.bind(this));
            },
		}
	};
</script>

<style scoped lang="scss">
	.custom-control{
		width: 130px;
		position: absolute;
		right: 130px;
		top: 13px;
	}
	.vue-table-loader.alt{
		padding-top: 20px;
	}
	.attribute-item{
		background-color: #fff;
		border:solid 1px #dee0e1;
		padding: 10px;
		margin-bottom: -1px;
	}
	.card {
		margin-bottom: 30px;
		.fa-chevron-right {
			transition: transform 0.3s linear;
		}
		.card-title {
			transition: border-bottom 0.3s linear;
			border-bottom:solid 1px transparent;
		}
		&.open {
			.created-display-groups {
				max-height:600px;
				overflow-y: auto;
				padding: 20px;
			}
			.card-title {
				transition: border-bottom 0.3s linear;
				border-bottom:solid 1px #dee0e1;
			}
			.fa-chevron-right {
				transition: transform 0.3s linear;
				transform: rotate(90deg);
			}
		}
	}
	.card{
		&.deleted{
			.card-title{
				border-bottom: 0;
				.copy{
					transition: color 0.4s;
					color:#fff;
					position: relative;
					z-index: 2;
				}
			}
			.card-body{
				transition: all 0.4s;
				max-height: 1px;
				opacity: 0;
				padding:0 20px;
				overflow: hidden;
			}
			.btn-flag-for-deletion{
				transition: width 0.4s;
				// width: 120px;
				width: calc(100% + 2px);
				font-size: 12px;
			}
		}
	}
	.card-title{
		position: relative;
		padding: 14px 20px 10px 20px;
		margin-bottom: 0px;
		min-height: 45px;
		.toggle-panel-icon {
			position: absolute;
			top: 16px;
			left: 15px;
		}
		.copy{
			transition: color 0.4s;
		}
		&.editable-group{
			padding: 10px 70px 10px 20px;
			margin-bottom: -1px;
		}
		&.no-action{
			padding: 12px 20px;
		}
	}
	.card-body{
		position: relative;
		transition: max-height 0.7s;
		&.created-display-groups{
			max-height: 0px;
			overflow-y: auto;
			transition: padding-top 0.2s linear, padding-bottom 0.2s linear;
			padding-top: 0;
			padding-bottom: 0;
			&::-webkit-scrollbar {
			    width: 4px;
			}
			&::-webkit-scrollbar-track {
			    background: rgba(0,0,0,0.1);
			    position: absolute;
			    top: 0px;
			    bottom: 0px;
			    right: 0px;
			}
			&::-webkit-scrollbar-thumb {
			    background: #909090;
			    border-radius:2px;
			}
			&::-webkit-scrollbar-thumb:hover {
			    background: #909090;
			}
		}
	}
	.view-attribute{
		font-size:18px;
		color: #c3c6ca;
		line-height: 19px;
	}
	.dragArea{
		position: relative;
		z-index: 2;
		min-height: 44px;
		span{
			min-height: 44px;
			display: block;
		}
	}
	.no-attribute-message{
		padding: 11px;
		position: absolute;
		z-index: 1;
		top: 20px;
		left: 20px;
		right: 20px;
		color: #bbbbbb;
		border:1px dashed #d8dadc;
		text-align: center;
	}
	.attribute-search{
		position: absolute;
		top: -1px;
		right: -1px;
		bottom: -1px;
		width: 220px;
		height: 46px;
	}
	.search-no-attributes{
		padding: 15px 10px;
		text-align: center;
		color: #b2b2b2;
	}
	.seach-icon{
		position: absolute;
	    top: 5px;
	    right: 0px;
	    bottom: 5px;
	    color: #d8dadc;
	    font-size: 13px;
	    font-size: 18px;
	    cursor: pointer;
	    border: 0;
	    padding: 0px 15px;
	    border-left: 1px solid #dedede;
	    background-color: white;
	}
	.add-display-group{
		transition: border-color 0.3s, color 0.3s;
		padding: 20px;
		border:2px dashed #d8dadc;
		color: #bbbbbb;
		cursor: pointer;
		text-align: center;
		i{
			margin-right: 5px;
			position: relative;
			font-size: 16px;
			top: 1px;
		}
		&:hover,
		&:active,
		&:focus{
			transition: border-color 0.3s, color 0.3s;
			border-color: #bbbbbb;
			color: #9c9999;
		}
	}
	.display-group-form-control{
		position: relative;
		margin-bottom:-1px;
		.name-error-message{
			position: absolute;
			top: 26px;
			right: 117px;
			color: #ec644b;
			font-size: 10px;
		}
		.form-control{
			border-top: 0;
			border-left: 0;
			font-size: 13px;
			padding-left: 20px;
			height: 45px;
			color: #333;
			border-radius: 0;
			&:focus,
			&:hover,
			&:active{
				border-color: #dee0e1;
			}
			&.has-error{
				background-color: red;
			}
		}
		.btn{
			height: 45px;
			border-bottom-right-radius: 0;
		}
	}
	.ks-checkbox-switch{
		margin-bottom: 0;
		width: 80px;
		> .ks-wrapper{
			width: 80px;
		}
		> .ks-on {
			left: 10px;
		}
		input[type=checkbox]:checked + .ks-wrapper + .ks-indicator{
			left: 60px;
		}
	}
	.copy{
		font-weight: 800;
		padding-top: 3px;
	}
	.btn-flag-for-deletion{
		transition: width 0.4s;
		position: absolute;
		z-index: 2;
	    right: -1px;
	    top: -1px;
	    bottom: -1px;
	    height: auto;
	    border-bottom-left-radius: 0;
	    border-top-left-radius: 0;
	    font-size: 17px;
	    padding: 0 20px;
	    width: 60px;
	    .btn-cancel{
			border-left: 1px solid white;
			padding-left: 15px;
			position: absolute;
			right: 20px;
			top: 5px;
			bottom: 5px;
			padding-top: 9px;
	    }
	    &:hover,
	    &:active,
	    &:focus{
	    	background: #AB5755 !important;
	    	    border: solid 1px #AB5755 !important;
	    }
	}
	.btn-flag-for-name-edit{
		transition: width 0.4s;
		position: absolute;
		z-index: 1;
    	right: 58px;
	    top: -1px;
	    bottom: -1px;
	    height: auto;
	    border-radius: 0;
	    font-size: 17px;
	    padding: 0 20px;
	    width: 60px;
	    color: #25628F;
	    border: solid 1px #dee0e1;
	    &:hover,
	    &:active,
	    &:focus{
	    	color: #25628F !important;
	    	border: solid 1px #dee0e1 !important;
	    }
	}
	.fade-enter-active, .fade-leave-active {
        transition: opacity .3s;
    }
    .fade-enter, .fade-leave-to{
        opacity: 0;
    }
    .navigationable-switch{
    	position: absolute;
    	right: 130px;
    }
	.view-collapse-all{
		color:#3191FF;
	}
	.card-title.no-actions {
		border-bottom:solid 1px #dee0e1;
	}
	.marked-for-deletion{
		font-weight: 400;
	}
</style>
